import { Link } from "react-router-dom";
import { buildWhatsAppLink, WHATSAPP_DISPLAY } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-12 lg:px-24 py-20 sm:py-28">
        <a
          href={buildWhatsAppLink("Hola Emmanuel, quiero trabajar contigo.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-shoot-cta"
          className="block group"
        >
          <p className="font-mono text-[10px] tracking-[0.4em] text-white/40">END CREDITS</p>
          <h2 className="mt-4 font-display uppercase font-bold leading-[0.85] tracking-tighter text-white">
            <span className="block text-[16vw] sm:text-[12vw] group-hover:text-[var(--magenta)] transition-colors duration-700">
              Let's
            </span>
            <span className="block text-[16vw] sm:text-[12vw] italic font-serif-accent font-normal text-[var(--tungsten)]">
              shoot.
            </span>
          </h2>
        </a>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-white/5 pt-10 font-mono text-[11px] tracking-[0.2em] text-white/60">
          <div>
            <p className="text-[10px] tracking-[0.4em] uppercase text-white/30">DIRECTOR</p>
            <p className="mt-3 text-white">EMMANUEL UPEGUI</p>
            <p className="mt-1 text-white/50">Cartagena, Colombia</p>
          </div>
          <div>
            <p className="text-[10px] tracking-[0.4em] uppercase text-white/30">CONTACT</p>
            <ul className="mt-3 space-y-1 text-white/80">
              <li><a className="link-reveal" data-testid="footer-whatsapp" href={buildWhatsAppLink("Hola Emmanuel.")} target="_blank" rel="noreferrer">WHATSAPP {WHATSAPP_DISPLAY}</a></li>
              <li><a className="link-reveal" href="https://instagram.com/e.upegui" target="_blank" rel="noreferrer">@E.UPEGUI</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[10px] tracking-[0.4em] uppercase text-white/30">ARCHIVE</p>
            <ul className="mt-3 space-y-1 text-white/80">
              <li><a className="link-reveal" href="https://www.behance.net/eupegui" target="_blank" rel="noreferrer">BEHANCE</a></li>
              <li><a className="link-reveal" href="https://500px.com/eupegui28" target="_blank" rel="noreferrer">500PX</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[10px] tracking-[0.4em] uppercase text-white/30">ROLLS</p>
            <ul className="mt-3 space-y-1 text-white/80">
              <li><Link className="link-reveal" to="/galeria/musica">02 · MÚSICA</Link></li>
              <li><Link className="link-reveal" to="/galeria/eventos">03 · EVENTOS</Link></li>
              <li><Link className="link-reveal" to="/galeria/viajes">04 · VIAJES</Link></li>
              <li><Link className="link-reveal" to="/prints">07 · PRINTS</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row justify-between gap-3 font-mono text-[10px] tracking-[0.4em] text-white/30">
          <span>© {new Date().getFullYear()} EUPEGUI · ALL RIGHTS RESERVED</span>
          <span>HIJO DE EDITH · PAPÁ DE LA NEGRA</span>
          <span>BUILT IN CARTAGENA, CO</span>
        </div>
      </div>
    </footer>
  );
}
